import { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Descriptions,
  Spin,
  Input,
  Tag,
  Card,
} from "antd";
import { ReloadOutlined, EyeOutlined } from "@ant-design/icons";
import { postAPI } from "../../utils/common"; // your existing api util
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Layout } from "antd";
import { WEBHOOKS_LOGS } from "../../constants/api";

function WebhookLogs() {
  const { Content } = Layout;

  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    setLoading(true);
    postAPI(
      WEBHOOKS_LOGS,
      {},
      (res) => {
        if (res.status) {
          const rows = res.data.map((log, index) => ({
            key: log.id,
            ...log,
          }));
          setLogs(rows);
          setFilteredLogs(rows);
        }
        setLoading(false);
      },
      () => setLoading(false),
    );
  };

  const handleSearch = (value) => {
    const search = value.toLowerCase().trim();
    setSearchText(value);
    if (!search) {
      setFilteredLogs(logs);
      return;
    }
    setFilteredLogs(
      logs.filter((item) =>
        Object.values(item).some(
          (val) =>
            val &&
            typeof val === "string" &&
            val.toLowerCase().includes(search),
        ),
      ),
    );
  };

  const showDetails = (log) => {
    setSelectedLog(log);
    setModalVisible(true);
  };

  const closeModal = () => {
    setSelectedLog(null);
    setModalVisible(false);
  };

  const columns = [
    { title: "ID", dataIndex: "id", width: 60 },
    { title: "Event", dataIndex: "event" },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        let color =
          status === "success"
            ? "green"
            : status === "failed"
              ? "red"
              : "orange";
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Source",
      dataIndex: "source",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} onClick={() => showDetails(record)}>
            View
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Wehook Logs"
          extra={
            <Space>
              <Input
                placeholder="Search logs..."
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 200 }}
              />
              <Button
                type="primary"
                icon={<ReloadOutlined />}
                onClick={fetchLogs}
              >
                Reload
              </Button>
            </Space>
          }
        >
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={filteredLogs}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 1000 }}
            />
          </Spin>
        </Card>

        {/* Modal */}
        <Modal
          title="Webhook Details"
          visible={modalVisible}
          onCancel={closeModal}
          footer={[
            <Button key="close" type="primary" onClick={closeModal}>
              Close
            </Button>,
          ]}
          width={800}
        >
          {selectedLog && (
            <Descriptions bordered column={1}>
              <Descriptions.Item label="ID">{selectedLog.id}</Descriptions.Item>
              <Descriptions.Item label="Event">
                {selectedLog.event}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {selectedLog.status}
              </Descriptions.Item>
              <Descriptions.Item label="Source">
                {selectedLog.source}
              </Descriptions.Item>
              <Descriptions.Item label="Payload">
                <pre style={{ maxHeight: "300px", overflow: "auto" }}>
                  {JSON.stringify(selectedLog.payload, null, 2)}
                </pre>
              </Descriptions.Item>
              <Descriptions.Item label="Response">
                <pre style={{ maxHeight: "300px", overflow: "auto" }}>
                  {JSON.stringify(selectedLog.response, null, 2)}
                </pre>
              </Descriptions.Item>
              <Descriptions.Item label="Created At">
                {new Date(selectedLog.created_at).toLocaleString()}
              </Descriptions.Item>
            </Descriptions>
          )}
        </Modal>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default WebhookLogs;
